/*
 * @Author: Huangxianlong
 * @Date: 2023-05-29 10:27:17
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-06-01 14:23:20
 * @FilePath: \monitor\src\router\router.js
 * @Description: 
 */
import Main from '@/view/Main.vue';

// 不作为Main组件的子页面展示的页面单独写，如下
export const loginRouter = {
  path: '/login',
  name: 'login',
  meta: {
    title: 'Login - 登录'
  },
  component: () => import('@/view/login/login.vue')
};

export const testRouter = {
  path: '/test',
  name: 'test',
  meta: {
    title: 'test - 测试'
  },
  component: () => import('@/view/test.vue')
};

export const registerRouter = {
  path: '/register',
  name: 'register',
  meta: {
    title: 'register - 注册'
  },
  component: () => import('@/view/login/register.vue')
};

export const forgetpwdRouter = {
  path: '/forgetpwd',
  name: 'forgetpwd',
  meta: {
    title: 'forgetpwd - 忘记密码'
  },
  component: () => import('@/view/login/forgetpwd.vue')
};

export const generatepageRouter = {
  path: '/generatepage',
  name: 'generatepage',
  meta: {
    title: 'generatepage - 页面生成'
  },
  component: () => import('@/view/generatepage.vue')
};

export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在'
  },
  component: () => import('@/view/error-page/404.vue')
};

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足'
  },
  name: 'error-403',
  component: () => import('@/view/error-page/403.vue')
};

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误'
  },
  name: 'error-500',
  component: () => import('@/view/error-page/500.vue')
};

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  redirect: '/home',
  component: Main,
  children: [
    { path: 'home', title: { i18n: 'home' }, name: 'home', component: () => import('@/view/home/home.vue') },
    { path: 'realtimechart', title: { i18n: 'realtimechart' }, name: 'realtimechart', component: () => import('@/view/realtimechart/index.vue') },
    { path: 'realtime', title: { i18n: 'realtime' }, name: 'realtime', component: () => import('@/view/realtimechart/realtime.vue') },
    { path: 'sensorData', title: { i18n: 'sensorData' }, name: 'sensorData', component: () => import('@/view/sensorData/sensorData.vue') },
    { path: 'project', title: { i18n: 'project' }, name: 'project', component: () => import('@/view/project/project-manage/project.vue') },
    { path: 'zone', title: { i18n: 'zone' }, name: 'zone', component: () => import('@/view/project/zone-manage/zone.vue') },
    { path: 'gzm', title: { i18n: 'gzm' }, name: 'gzm', component: () => import('@/view/project/gzm-manage/gzm.vue') },
    { path: 'datalogger', title: { i18n: 'datalogger' }, name: 'datalogger', component: () => import('@/view/project/datalogger-manage/datalogger.vue') },
    { path: 'dailyreport', title: { i18n: 'dailyreport' }, name: 'dailyreport', component: () => import('@/view/report/daily-report/dailyReport.vue') },
    { path: 'report', title: { i18n: 'report' }, name: 'report', component: () => import('@/view/report/report.vue') },
    { path: 'overview-report', title: { i18n: 'overview-report' }, name: 'overview-report', component: () => import('@/view/report/overviewReport.vue') },
    { path: 'strainGauge-report', title: { i18n: 'strainGauge-report' }, name: 'strainGauge-report', component: () => import('@/view/report/strainGaugeReport.vue') },
    { path: 'totalStation-report', title: { i18n: 'totalStation-report' }, name: 'totalStation-report', component: () => import('@/view/report/totalStationReport.vue') },
    { path: 'vm2030-report', title: { i18n: 'vm2030-report' }, name: 'vm2030-report', component: () => import('@/view/report/vm2030Report.vue') },
    { path: 'an1001-report', title: { i18n: 'an1001-report' }, name: 'an1001-report', component: () => import('@/view/report/an1001Report.vue') },
    { path: 'layoutplan', title: { i18n: 'layoutplan' }, name: 'layoutplan', component: () => import('@/view/layoutplan/layoutplan.vue') },
    { path: 'user', title: { i18n: 'user' }, name: 'user', component: () => import('@/view/system/user-manage/user.vue') },
    { path: 'alarm', title: { i18n: 'alarm' }, name: 'alarm', component: () => import('@/view/system/alarm-record/alarm.vue') },
    { path: 'testMap', title: { i18n: 'testMap' }, name: 'testMap', component: () => import('@/view/testMap.vue') },
    { path: 'mark', title: { i18n: 'mark' }, name: 'mark', component: () => import('@/view/mark.vue') },
  ]
};
// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  otherRouter,
  forgetpwdRouter,
  loginRouter,
  generatepageRouter,
  registerRouter,
  testRouter,
  page500,
  page403,
  page404,
];



// WEBPACK FOOTER //
// ./src/router/router.js